import { restoreContentsAction } from '~src/spacesPlatform/actions/RestoreContentAction';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { IRestoreAction as IRestoreActionApi } from '../../../models/actionNames';
import { IContentInfo } from '../../../models/IContentInfo';
import { isRecycleBinSpace } from '../../../state/SpaceInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const RestoreAction: IEntityAction<IContentInfo, IRestoreActionApi> = {
  name: EntityActionNames.Restore,
  translateName: Messages.restoreActionTitle,
  isVisible: (targetItems: IContentInfo[], state: AppState) => {
    return isRecycleBinSpace(state.spaceInfo);
  },
  isClickable: (availableActions: IRestoreActionApi, targetItems: IContentInfo[]) => {

    // Check if any of the target items are read-only archived content
    const hasReadOnlyContent = targetItems.some(item => item.isArchivedReadOnly);

    // Leaving off availableActions.restore check since this should always
    // be enabled when in the Recycle Bin space (the isVisible criteria)
    return !!(availableActions) && !hasReadOnlyContent;
  },
  createReduxAction: (targetItems: IContentInfo[]) => {
    return restoreContentsAction(targetItems);
  },
};